module.exports = "/images/wave-footer.svg?cb790cfa3df0528d2d3efdb517a83459";